import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type SaveToDraftDialogProps = Omit<DialogProps, 'children'> & {
  onCancel?: () => void
  onConfirm?: () => void
  isLoading?: boolean
}

/**
 * @deprecated: use `KinerjaShared/components/ConfirmationDialog` instead
 */
export function SaveToDraftDialog({
  onCancel,
  onConfirm,
  isLoading,
  ...dialogProps
}: SaveToDraftDialogProps) {
  return (
    <Dialog size="sm" {...dialogProps} autoFocus={false}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <div className="space-y-3">
            <Text variant="display-sm">Simpan draf sebelum keluar?</Text>
            <Text color="subdued" variant="body-lg">
              Pilihan Anda akan disimpan dan bisa dilanjutkan nanti. Jika lewat
              batas waktu, draf akan otomatis dikumpulkan.
            </Text>
          </div>
          <div className="flex space-x-5">
            <Button
              onClick={onCancel}
              color="white"
              size="lg"
              disabled={isLoading}
              className="min-w-[155px]"
              autoFocus={false}
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              color="blue"
              size="lg"
              disabled={isLoading}
              isLoading={isLoading}
              className="min-w-[155px]"
              autoFocus={false}
            >
              Simpan dan keluar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
